import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { onBasePath } from '../../paths/onBasePath';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './BusinessLog.translations.json';
import { SectionContextProvider } from '../../common/SectionContext';
import { NotFound } from '../NotFound';
import { BusinessLogDirectory } from './BusinessLogDirectory';

const { addTranslations, Translation } = i18nNsFactory('business-log');
addTranslations(translations);

export const BUSINESS_LOG_ROUTES = [
  {
    path: '/',
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.business-log')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <BusinessLogDirectory />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export interface BusinessLogProps {
  basePath: string;
}

export const BusinessLog: FC<BusinessLogProps> = ({ basePath }) => (
  <SectionContextProvider basePath={basePath}>
    {useRoutes(onBasePath(basePath, BUSINESS_LOG_ROUTES))}
  </SectionContextProvider>
);
